
import { BrowserRouter, Routes, Route } from "react-router-dom";  
import Home from'./Pages/Home'  
import AboutUs from'./Pages/AboutUs'
import Admission from'./Pages/Admission'   
import Attendance from'./Pages/Attendance'   
import ContactUs from'./Pages/ContactUs'   
import Fees from'./Pages/Fees'    
import Gallery from'./Pages/Gallery'
import SubGallery from'./Pages/SubGallery'
import News from'./Pages/News' 
import Events from'./Pages/Events'
import PrincipalMessage from'./Pages/PrincipalMessage'
import VideoGallery from'./Pages/VideoGallery'   
import Toppers from'./Pages/Toppers'  
import ToppersXII from'./Pages/ToppersXII' 
import Withdrawals from'./Pages/Withdrawals'   
import ErpSoftware from'./Pages/ErpSoftware'  
import Tc from'./Pages/Tc'  
import Curriculum from'./Pages/Curriculum'
import Footer from'./Component/Footer'
import Uniform from'./Pages/Uniform'
import Examination from'./Pages/Examination'
import Library from'./Pages/Library'
import SchoolHours from'./Pages/SchoolHours'
import JRHome from'./Junior/Home'  
import JRAdmission from'./Junior/Admission'   
import JRAttendance from'./Junior/Attendance'    
import JRFees from'./Junior/Fees'        
import JRSchoolHours from'./Junior/SchoolHours'
import JRCurriculum from'./Junior/Curriculum'
import Pphelp from'./Pages/Pphelp'
import Cbse from'./Pages/Cbse'
function App() { 
  return (
      <>
      <BrowserRouter> 
      <Routes>
       <Route path="/" element={<Home/>} /> 
        <Route path="/Cbse" element={<Cbse/>} /> 
       <Route path="/AboutUs" element={<AboutUs/>} />
       <Route path="/Admission" element={<Admission/>} /> 
       <Route path="/Attendance" element={<Attendance/>} /> 
       <Route path="/ContactUs" element={<ContactUs/>} /> 
       <Route path="/Fees" element={<Fees/>} /> 
       <Route path="/Gallery" element={<Gallery/>} /> 
       <Route path="/SubGallery" element={<SubGallery/>} /> 
       <Route path="/News" element={<News/>} />  
       <Route path="/Curriculum" element={<Curriculum/>} />
       <Route path="/Events" element={<Events/>} /> 
       <Route path="/Pphelp" element={<Pphelp/>} />
       <Route path="/PrincipalMessage" element={<PrincipalMessage/>} /> 
       <Route path="/Toppers" element={<Toppers/>} /> 
       <Route path="/ToppersXII" element={<ToppersXII/>} /> 
       <Route path="/VideoGallery" element={<VideoGallery/>} /> 
       <Route path="/Withdrawals" element={<Withdrawals/>} /> 
       <Route path="/ErpSoftware" element={<ErpSoftware/>} /> 
       <Route path="/Tc" element={<Tc/>} /> 
       <Route path="/Uniform" element={<Uniform/>} />
        <Route path="/Examination" element={<Examination/>} />
         <Route path="/Library" element={<Library/>} />
         <Route path="/SchoolHours" element={<SchoolHours/>} /> 
         <Route path="/JuniorHome" element={<JRHome/>} /> 
         <Route path="/Junior/Admission" element={<JRAdmission/>} /> 
        <Route path="/Junior/Attendance" element={<JRAttendance/>} />  
        <Route path="/Junior/Fees" element={<JRFees/>} />     
        <Route path="/Junior/SchoolHours" element={<JRSchoolHours/>} />
        <Route path="/Junior/Curriculum" element={<JRCurriculum/>} />
          
      </Routes> 
      <Footer/>
     </BrowserRouter>
      </>
  )
}

export default App;
